import React from 'react'

import { CUSTOM_TEMPLATE } from '../../../_templates/Constants'
import { HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE } from '../../../_templates/Templates'
import Text, { Label } from '../../../../../../packages/kiti/components/presentation/Text'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import SliderInput from '../../../../../../components/form/SliderInput'
import LabelValue from '../../../../../../packages/kiti/components/presentation/LabelValue'
import Line from '../../../../../../packages/kiti/components/helpers/Line'

export const TemplateSize = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  const isVertical = form.template === VERTICAL_TEMPLATE
  const proportion = isVertical ? 4 / 3 : 16 / 9
  const dynamicWidthValue = isVertical ? form.templateWidth * proportion : form.templateWidth / proportion

  if (![CUSTOM_TEMPLATE, HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE].includes(form.template)) return false

  return (
    <>
      <Label>Largura (cm)</Label>
      <SliderInput value={form.templateWidth} onChange={handleChange('templateWidth')} step="0.1" min="0" max="30" />
      <Separator weight={4} />
      <Line />
      <Separator weight={2} />
      <Grid align="center" gap={1}>
        <Col width="50%" align="center">
          <LabelValue label="Largura (cm)" value={Number(form.templateWidth).toFixed(1)} align="center" />
        </Col>
        <Col width="50%" align="center">
          <LabelValue label="Altura (cm)" value={Number(dynamicWidthValue).toFixed(1)} align="center" />
        </Col>
      </Grid>
      <Line />
      <Separator weight={4} />
    </>
  )
}

export default TemplateSize
